import { IUpdateTargetBehavior } from "../../../interfaces/form-builder/i-behavior";
import { NoteDataManager } from "./../note-data-manager";
import { autoinject } from "aurelia-framework";

// Update Target behavior is used to override the given target's value when the source condition values are met
// For example: If the Shortness of Breath Impact is rated as a 1-10, Did Shortness of Breath Screening indicate should be 1/Yes, otherwise (e,g, a 0) it should be set to 0/No

@autoinject
export class UpdateTargetBehaviorHandler {
    // Only currently supported by/for Single-Select
    public handle(
        behavior: IUpdateTargetBehavior,
        noteDataManager: NoteDataManager,
        sourceValue: string | string[]
    ): boolean {
        if (!behavior) {
            return false;
        }
        let targetName = noteDataManager.getModelKeyFromTargetName(behavior.targetName);
        if (targetName === undefined) {
            return false;
        }

        if (!behavior.sourceValues || !behavior.sourceValues.some((val) => val == sourceValue)) {
            return false;
        }

        noteDataManager.updatePropInModifiedData(behavior.targetName, behavior.updatedTargetValue, false);
        noteDataManager.refreshValueInView(behavior.targetName);
        return true;
    }
}
